import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import './equipment-card.css';

export default class EquipmentCard extends React.PureComponent {
  render() {
    const { equipment } = this.props;
    return (
      <div className="equipment-card">
        <div className="equipment-card-main">
          <div className="equipment-card-image">
            {equipment.model_image ? (
              <img
                src={equipment.model_image}
                alt={equipment.model_name}
              />
            ) : (
              <div className="equipment-card-placeholder">
                <Icon name="cog" size="big" />
              </div>
            )}
          </div>
          <div className="equipment-card-info">
            <h3 className="equipment-name">{equipment.model_name}</h3>
            <div className="equipment-detail">
              <span className="detail-label">Vendor</span>
              <span className="detail-value">{equipment.vendor_name}</span>
            </div>
            {equipment.location_description && (
              <div className="equipment-detail">
                <span className="detail-label">Location</span>
                <span className="detail-value">
                  {equipment.location_description}
                </span>
              </div>
            )}
            {equipment.serial_number && (
              <div className="equipment-detail">
                <span className="detail-label">Serial</span>
                <span className="detail-value">
                  {equipment.serial_number}
                </span>
              </div>
            )}
            {equipment.installation_date && (
              <div className="equipment-detail">
                <span className="detail-label">Installed</span>
                <span className="detail-value">
                  {new Date(
                    equipment.installation_date + 'T00:00:00'
                  ).toLocaleDateString()}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

EquipmentCard.propTypes = {
  equipment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    model_name: PropTypes.string.isRequired,
    model_image: PropTypes.string,
    vendor_name: PropTypes.string,
    location_description: PropTypes.string,
    serial_number: PropTypes.string,
    installation_date: PropTypes.string,
  }).isRequired,
};
